<template>
  <multiselect 
    placeholder="Select Driver"
    :options="drivers.data" 
    label="name" 
    track-by="id" 
    :value="selected" 
    @search-change="handleSearch"
    @input="handleInput" 
    @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div>{{ props.option.name }}</div>
      <div class="mt-1 text-sm text-gray-500 ">{{ props.option.objectno }}</div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'DriverSelect',

  components: {
    Multiselect
  },

  created () {
    this.getDrivers()
  },

  props: ['value'],

  computed: {
    selected () {
      return this.drivers.data.find(driver => driver.id === this.value)
    }
  },

  data () {
    return {
      drivers: {
        data: []
      }
    }
  },

  methods: {
    async getDrivers (query) {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/drivers`, {
          params: {
            search: query
          }
        })
        this.drivers = data.drivers
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    
    handleSearch (query) {
      this.getDrivers(query)
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>